document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    // 找到 Judge.me Review Widget 容器
    var reviewEl = document.querySelector('.jdgm-widget, .jdgm-rev-widg, [data-widget-type="review_widget"]');
    // 找到页面评分区块
    var ratingEl = document.querySelector('.product__rating, .rating, [class*="product-rating"]');

    if (reviewEl) {
      reviewEl.id = 'jm-reviews';
    }

    if (ratingEl && reviewEl) {
      ratingEl.style.cursor = 'pointer';
      ratingEl.addEventListener('click', function () {
        reviewEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }, 2000); // Judge.me 异步加载，等待 2 秒
});